import React, { Fragment } from 'react';
import T from 'prop-types';
// components
import Popover from 'components/Popover';
import TreatmentFarmfeedTooltip from 'components/EntityFarmfeedTooltip/TreatmentFarmfeedTooltip';
// utils
import { isMobile } from 'react-device-detect';
import moment from 'moment';
import { useIntl } from 'react-intl';

const TreatmentPopoverList = ({ treatments, isCurrentUserAdmin, columnView, hideClearanceDates = false }) => {
  const intl = useIntl();
  const truncateLimit = isMobile ? 14 : 20;

  const renderClearanceDate = (date) => {
    if (!date) return intl.formatMessage({ id: 'general.notAvail' });
    const dateObj = moment(date);
    return dateObj.isBefore(moment(), 'day')
      ? intl.formatMessage({ id: 'general.clear' })
      : dateObj.format('MM/DD/YYYY');
  };

  return (
    <>
      {treatments.map((treatment, index) => {
        const { id, name, us_clearance_date, export_clearance_date } = treatment;
        const displayName =
          columnView && name.length > truncateLimit ? `${name.slice(0, truncateLimit)}…` : name;

        const item = (
          <Popover
            content={<TreatmentFarmfeedTooltip treatmentId={id} isAdmin={isCurrentUserAdmin} />}
            placement="bottomLeft"
          >
            <span title={name}>{displayName}</span>
          </Popover>
        );

        const clearanceDates = !hideClearanceDates ? (
          <div style={{ fontSize: '0.9em', color: '#666', marginTop: '2px' }}>
            <div>{intl.formatMessage({ id: 'general.usPrefix' })} {renderClearanceDate(us_clearance_date)}</div>
            <div>{intl.formatMessage({ id: 'general.exportPrefix' })} {renderClearanceDate(export_clearance_date)}</div>
          </div>
        ) : null;

        return columnView ? (
          <div key={id} style={{ marginBottom: 4 }}>
            {item}
            {clearanceDates}
          </div>
        ) : (
          <Fragment key={id}>
            {item}
            {clearanceDates}
            {!!treatments[index + 1] && ', '}
          </Fragment>
        );
      })}
    </>
  );
};

TreatmentPopoverList.propTypes = {
  treatments: T.array.isRequired,
  isCurrentUserAdmin: T.bool.isRequired,
  columnView: T.bool,
  hideClearanceDates: T.bool,
};

export default TreatmentPopoverList;
